interface LogoProps {
  size?: number;
}

export const TKLogo = ({ size = 28 }: LogoProps) => {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-label="TradeKaro">
        <rect x="1" y="1" width="30" height="30" rx="9" fill="var(--tk-accent)" />
        <path
          d="M9 21.5 L9 11 M9 11 L13.5 15 M13.5 15 L13.5 21.5 M18 21.5 L18 10.5 M18 16 L24 10.5 M21 13 L24 21.5"
          stroke="var(--tk-accent-ink)"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span
        style={{
          fontFamily: 'var(--tk-sans)',
          fontWeight: 700,
          fontSize: size * 0.62,
          letterSpacing: '-0.02em',
          color: 'var(--tk-ink)',
        }}
      >
        TradeKaro
      </span>
    </div>
  );
};
